module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point05_04_sunset-a780a2b4bbff7a60e97fea456ae61b28.jpg";